// عدّاد طلبات الإجازة المعلّقة — **رقم من الخادم لا حساب في الواجهة**.
//
// المصدر هو `pendingCount` القائم في `/admin/leave` منذ وحدة الحضور: يعدّ الطلبات المعلّقة
// وحدها، ولا يتأثّر بمرشّحات العرض. فلا مسار جديد ولا منطق ثانٍ — والواجهة تعرض ما يقوله
// الخادم. ويُطلب بـ`limit=1` لأن المطلوب العدّاد لا القائمة.
//
// ولا استقصاء دوري: يُقرأ عند فتح الجلسة، وعند كل تنقّل بين التبويبات، وبعد كل قرار إجازة
// (تمرّره شاشة «الحضور والإجازات»). فالرقم يتبع الحقيقة بلا مؤقّت يستهلك الخادم بلا داعٍ.
//
// وللأدمن وحده: الخادم يرفض المسار بـ403 لغيره، وهذا الخطّاف لا يطلبه أصلًا إن لم يكن أدمن.
import { useCallback, useEffect, useState } from 'react';
import { get } from '../../lib/api.ts';

export function usePendingLeaves(enabled: boolean, refreshKey: unknown): { count: number; refresh: () => void } {
  const [count, setCount] = useState(0);
  const [tick, setTick] = useState(0);

  const refresh = useCallback(() => setTick(t => t + 1), []);

  useEffect(() => {
    if (!enabled) { setCount(0); return; }
    let alive = true;
    void (async () => {
      try {
        const r = await get<{ pendingCount: number }>('/admin/leave?limit=1&offset=0');
        if (alive) setCount(Number(r.pendingCount) || 0);
      } catch {
        // الشارة تنبيه لا قاعدة: فشل القراءة يخفيها ولا يوقف الشاشة
        if (alive) setCount(0);
      }
    })();
    return () => { alive = false; };
  }, [enabled, refreshKey, tick]);

  return { count, refresh };
}
